import { render } from "./UnggulanPropView.vue?vue&type=template&id=b0ac4c56&scoped=true"
import script from "./UnggulanPropView.vue?vue&type=script&lang=js"
export * from "./UnggulanPropView.vue?vue&type=script&lang=js"

import "./UnggulanPropView.vue?vue&type=style&index=0&id=b0ac4c56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ac4c56"]])

export default __exports__